// extracted by mini-css-extract-plugin
export default {"root":"K5ENc","items":"hkrQb","submit":"wmJGS"};